import React from 'react'
import {
	CContainer,
	CDropdown,
	CDropdownHeader,
	CDropdownItem,
	CDropdownMenu,
	CDropdownToggle,
	CHeader,
	CHeaderNav,
	CNavItem,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilAccountLogout, cilChevronCircleDownAlt, cilLockLocked, cilUser } from '@coreui/icons'

export default class Header extends React.Component {

	render() {

		return (
			<CHeader position="sticky" className="">
				<CContainer fluid>
					<CHeaderNav className="d-none d-md-flex me-auto">
						<CNavItem>
							Doubt Clearing App Admin Console
						</CNavItem>
					</CHeaderNav>
					<CHeaderNav className="ms-3">
						<CDropdown variant="nav-item">
							<CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
								<CIcon icon={cilUser} size="md" className="me-1" />
								Admin
								<CIcon icon={cilChevronCircleDownAlt} size="md" className="ms-1" />
							</CDropdownToggle>
							<CDropdownMenu className="pt-0" placement="bottom-end">
								<CDropdownHeader className="bg-light fw-semibold py-2">Account</CDropdownHeader>
								<CDropdownItem href="#" onClick={() => {this.props.addnlActions("CHANGE_PWD")}}>
									<CIcon icon={cilLockLocked} className="me-2" />
									Change Password
								</CDropdownItem>
								<CDropdownItem href="#" onClick={() => {this.props.addnlActions("LOGOUT")}}>
									<CIcon icon={cilAccountLogout} className="me-2" />
									Logout
								</CDropdownItem>
							</CDropdownMenu>
						</CDropdown>
					</CHeaderNav>
				</CContainer>
			</CHeader>
		)
	}
}
